import React from "react";
import styled from "styled-components";
import { Layout, Divider, Row, Col } from "antd";
import { Colors, Metrics } from "../../theme";
import { OButtonGroup } from "../button";

const { Content, Header } = Layout;
const Box = ({children, style, nodivider = false})=>(
	<Content style={style}>
		{children}
		{nodivider ? 
			undefined : 
			<Divider />
		}
	</Content>
);

const BoxHeader = styled(Header)`
    background-color:${Colors.backgroundColor};
    color: ${Colors.fontColor};
    padding-left: 0px;
    padding-right: 0px;
`;

const HeaderToolbar = (props)=>(<BoxHeader>
	<Row type="flex" justify ='space-between' align='middle'>
		<Col style={{fontWeight: Metrics.boldFontWeight, fontSize: Metrics.fontSize.header}}>
			{props.header}
		</Col>
		<Col>
			<OButtonGroup {...props} />
		</Col>
	</Row>
</BoxHeader>);

const AppendContentBox = styled(Content)`
    padding-top:${Metrics.button.bigSpaceMargin}px;
`;
export default {
	Box,
	BoxHeader,
	HeaderToolbar,
	AppendContentBox,
};


// WEBPACK FOOTER //
// ./src/components/layout/ContentBox.js